import Debug from 'debug'

const debug = Debug('error')

const alreadyEnriched = Symbol('enriched')

export function enrichError(error: any, ...context: any[]) {
  let richMessage
  try {
    if (context && context.length > 0 && !error[alreadyEnriched]) {
      richMessage = `[${new Date().getTime()}]${context.map(value => `[${value}]`).join(' ')} ${error.message}`
      // Some errors (DOMException, ZodError) only have a getter for message,
      // so define an own property instead of assigning through the setter.
      Object.defineProperty(error, 'message', {
        value: richMessage,
        writable: true,
        configurable: true,
      })
      Object.defineProperty(error, alreadyEnriched, {
        value: true,
        configurable: true,
      })
    }
  } catch (e) {
    debug(richMessage, e)
  }
  return error
}
